import { createContext, useContext, useReducer } from 'react';
import ajaxTag from '../util/remote/ajaxTag';

const initialState = { 
    tagListing: null,
    tagCount: '...'
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const TagContext = createContext();

export const TagProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  const getTagListing = async (refresh) => {

    if(!refresh && Array.isArray(state.tagListing)){
      return
    }
    dispatch({ type: 'tagListing', payload: null });
      const server_response  = await ajaxTag.listTags();
      if(server_response.status === "OK"){
          dispatch({ type: 'tagListing', payload: server_response.details });
      }else{
        dispatch({ type: 'tagListing', payload: '404' });

      }
  };

  const getTagCount = async () => {
    const server_response  = await ajaxTag.fetchTagCount();
    if(server_response.status === "OK"){
        dispatch({ type: 'tagCount', payload: server_response.details.total_p });
    }
  };

  return(
    <TagContext.Provider value={{
      ...state, 
      dispatch, 
      getTagListing,
      getTagCount,
      }}>
      {children}
    </TagContext.Provider>
  )

}

export const useTag = ()=>useContext(TagContext);

